// extracted by mini-css-extract-plugin
export default {"done":"DoneIcon_done__b6x-W","btnAnimation":"DoneIcon_btnAnimation__a7Cv9","done__G":"DoneIcon_done__G__lCfnC","done__P":"DoneIcon_done__P__FQYu4"};